"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = void 0;
exports.deepCopy = function (inObject) {
    var value;
    var key;
    if (typeof inObject !== "object" || inObject === null) {
        return inObject;
    }
    var outObject = Array.isArray(inObject) ? [] : {};
    // eslint-disable-next-line guard-for-in
    for (key in inObject) {
        value = inObject[key];
        outObject[key] = exports.deepCopy(value);
    }
    return outObject;
};
//# sourceMappingURL=deep-copy.js.map